import styled, { css } from "styled-components";

export const TitleArtical = styled.h3`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    margin: 0;
    font-size: 1.25rem;

    @media (min-width: 768px) {
      font-size: 1.5rem;
    }
  `}
`;

export const DatePusblished = styled.span`
  ${({ theme }) => css`
    display: block;
    color: ${theme.colors.black};
    opacity: 0.5;
    font-size: 0.75rem;
  `}
`;

export const ManyImagesPublished = styled.div`
  ${({ theme }) => css`
    margin: 1rem 0;
    display: flex;
    flex-direction: column;

    > img {
      border-radius: 8px;

      & + img {
        margin-top: 1rem;
      }
    }

    @media (min-width: 768px) {
      flex-direction: row;
      > img {
        height: 280px;
        width: 160px;

        & + img {
          margin-top: 0rem;
          margin-left: 1rem;
        }
      }
    }
  `}
`;

export const ImagePublished = styled.div`
  ${({ theme }) => css`
    margin: 1rem 0;
    display: flex;
    flex-direction: column;

    > img {
      border-radius: 8px;
    }

    > span {
      display: block;
      color: ${theme.colors.black};
      opacity: 0.5;
      font-size: 0.75rem;
      margin-top: 0.75rem;
    }

    @media (min-width: 768px) {
      > img {
        height: 280px;
        width: 160px;
      }
    }
  `}
`;

export const AboutArticle = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    margin: 1.5rem 0 3rem;

    > p {
      margin: 0;

      & + p {
        padding-top: 1rem;
      }
    }

    a {
      text-decoration: underline;
      color: ${theme.colors.primary};

      &:hover {
        color: ${theme.colors.transactionSecondary};
      }
    }

    h3 {
      margin: 0;
      padding: 0.5rem 0;
    }

    @media (min-width: 768px) {
      margin: 1.5rem 0;
    }
  `}
`;
